module.exports = __webpack_public_path__ + "static/media/BLUSH_6623.6adcffa1.jpg";